import { buildStandardReducer } from 'utils/reducer-utils';
import * as types from './action-types';

export default buildStandardReducer(types);
